
export const dialogStatusConstant = {
  create: 'create',
  update: 'update'
}

export const statusType = {
  0: 'success',
  1: 'warning'
}

// 考试类型
export const examType = {
  0: '正式考试',
  1: '模拟考试',
  2: '在线练习',
  3: '调查问卷'
}

// 题目类型
export const subjectType = {
  0: '单选题',
  2: '判断题',
  1: '简答题',
  3: '多选题'
}

export const subjectTypeTag = {
  0: 'success',
  1: 'info',
  2: 'warning',
  3: 'default'
}



// WEBPACK FOOTER //
// ./src/utils/constant.js